import React from 'react';
import Reveal from '../components/Reveal';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-transparent text-on-surface">
      <div className="max-w-container-max mx-auto">
        <Reveal>
          <div className="mb-16">
            <h1 className="font-display-lg text-display-lg text-on-surface mb-6">
              TERMS OF <span className="text-secondary font-medium">SERVICE</span>
            </h1>
            <div className="w-12 h-px bg-secondary mb-8"></div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="glass-panel p-8 md:p-12 prose prose-invert max-w-none">
            <h2 className="text-secondary mb-4">1. Acceptance of Terms</h2>
            <p className="text-on-surface-variant mb-6">
              By accessing and using the HBB0011 Realty website, you accept and agree to be bound by the terms and provisions of this agreement.
            </p>

            <h2 className="text-secondary mb-4">2. Use of Site</h2>
            <p className="text-on-surface-variant mb-6">
              You agree to use this site only for lawful purposes, and in a manner that does not infringe the rights of, or restrict or inhibit the use and enjoyment of this site by any third party.
            </p>

            <h2 className="text-secondary mb-4">3. Intellectual Property</h2>
            <p className="text-on-surface-variant mb-6">
              All content included on this site, such as text, graphics, logos, images, and software, is the property of HBB0011 Realty or its content suppliers and protected by international copyright laws.
            </p>

            <h2 className="text-secondary mb-4">4. Limitation of Liability</h2>
            <p className="text-on-surface-variant mb-6">
              HBB0011 Realty shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access to, or use of, the site.
            </p>

            <h2 className="text-secondary mb-4">5. Modifications</h2>
            <p className="text-on-surface-variant mb-6">
              We reserve the right to revise these terms of service at any time without notice. By using this website you are agreeing to be bound by the then-current version of these Terms of Service.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  );
};

export default TermsOfService;
